import { render, staticRenderFns } from "./GseedGradeChart.vue?vue&type=template&id=63af6713&scoped=true"
import script from "./GseedGradeChart.vue?vue&type=script&lang=js"
export * from "./GseedGradeChart.vue?vue&type=script&lang=js"
import style0 from "./GseedGradeChart.vue?vue&type=style&index=0&id=63af6713&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af6713",
  null
  
)

export default component.exports